import React, { useMemo } from "react";
import { isEmpty } from "lodash";
import { CellRenderers } from "utils/tableUtils";
import ContentOverlay from "components/ContentOverlay";

import GenericPullConfigListing from "../GenericPullConfigListing";
import HCLAppscanCloudCredentialsForm from "./HCLAppscanCloudCredentialsForm";
import HCLAppscanCloudMappingForm from "./HCLAppscanCloudMappingForm";

const renderSemicolonSeparatedData = (data) => {
  if (isEmpty(data)) {
    return CellRenderers.VALUE_OR_NA(data);
  }
  const renderData = data.split(';');
  const renderName = renderData.map((item, i) => (
    <p key={i} className={i === renderData.length - 1 ? "m-b-0" : ""}>{item}</p>
  ));
  return <ContentOverlay content={renderName} minHeight={40} />;
};

const HCLAppscanCloudConfigListing = (props) => {
  const columns = useMemo(
    () => [
      {
        title: "Applications",
        dataIndex: "applicationName",
        width: 130,
        render: renderSemicolonSeparatedData,
      },
    ],
    [],
  );

  return (
    <GenericPullConfigListing
      {...props}
      toolName={props.name}
      MappingForm={HCLAppscanCloudMappingForm}
      CredentialsForm={HCLAppscanCloudCredentialsForm}
      extraColumns={columns}
    />
  );
};

export default HCLAppscanCloudConfigListing;
